import { useState } from 'react';

import { useActivityBuilderContext } from 'approot/activity-builder/activity-builder.context';
import { useSimpleModalState } from 'approot/shared/modal/modal.hooks';
import { SettingsProps } from './image-sphere.constants';
import {
  ActivityBuilderDrawerContent,
  ActivityBuilderDrawerHeader,
  ActivityBuilderDrawerWrapper,
} from 'approot/activity-builder/activity-builder-drawer';
import {
  SettingsGroup,
  SettingsLabel,
} from 'approot/activity-builder/settings/settings.style';
import ComponentImageField from '../shared/component-image-field/component-image-field';
import ImageSphereEditModalWrapper from './image-sphere-edit-modal';
import ImageSphereCreate from './image-sphere-create';
import { FileDropperContextProvider } from 'lib/form/file-dropper/file-dropper.context';
import { MoreInfo } from '../shared/more-information/more-information-toolip';

const ImageSphereSettings = (props: SettingsProps) => {
  const { properties } = props;

  const [newFileProps, setNewFileProps] = useState<{
    key: string;
    fileName: string;
    file: File;
  }>();

  const { closeDrawer } = useActivityBuilderContext();
  const { isVisible, openModal, closeModal } = useSimpleModalState();

  return (
    <ActivityBuilderDrawerWrapper
      captureKeypresses={false}
      onCloseByEscape={closeDrawer}
    >
      <ActivityBuilderDrawerHeader title="360° Image" onClose={closeDrawer} />
      <ActivityBuilderDrawerContent>
        {isVisible && (
          <ImageSphereEditModalWrapper
            {...props}
            fileToUpload={newFileProps}
            onClose={closeModal}
          />
        )}
        <SettingsGroup>
          <SettingsLabel>
            360° Image Upload{' '}
            <MoreInfo>
              Please upload a special 360-degree image file that allows viewers
              to look in all directions—ensure the file is in a wide, panoramic
              format to avoid issues with incorrect uploads.
            </MoreInfo>
          </SettingsLabel>
          {properties.image ? (
            <ComponentImageField
              image={
                properties.image
                  ? {
                      key: properties.image.key,
                      fileName: properties.image.fileName,
                      original: properties.image.original,
                      flip: properties.image.data?.flip,
                      alt: properties.altText,
                    }
                  : null
              }
              ariaLabel="Edit Image Sphere"
              onEdit={openModal}
            />
          ) : (
            <FileDropperContextProvider>
              <ImageSphereCreate
                {...props}
                onShowModal={newFileProps => {
                  setNewFileProps(newFileProps);
                  openModal();
                }}
              />
            </FileDropperContextProvider>
          )}
        </SettingsGroup>
      </ActivityBuilderDrawerContent>
    </ActivityBuilderDrawerWrapper>
  );
};

export default ImageSphereSettings;
